import { render } from "./NewsIndex.vue?vue&type=template&id=6daad480&scoped=true"
import script from "./NewsIndex.vue?vue&type=script&lang=js"
export * from "./NewsIndex.vue?vue&type=script&lang=js"

import "./NewsIndex.vue?vue&type=style&index=0&id=6daad480&scoped=true&lang=css"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6daad480"]])

export default __exports__